import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";

const ProjectGallery = ({ gallery = [] }) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const baseImageBucketUrl = process.env.REACT_APP_S3_IMAGE_BUCKET_URL;

  if (!gallery.length) return null;

  const images = gallery.map((src) => `${baseImageBucketUrl}${src}`);

  return (
    <Box component="section" sx={{ px: { xs: 2, md: 7 }, py: { xs: 6, md: 9 }, backgroundColor: "#eeece5" }}>
      <Box sx={{ maxWidth: 1280, mx: "auto" }}>
        <Typography
          sx={{
            mb: 1.5,
            color: "#9a794b",
            fontSize: "0.68rem",
            fontWeight: 600,
            letterSpacing: "0.18em",
            textAlign: "center",
          }}
        >
          THE GALLERY
        </Typography>
        <Typography
          component="h2"
          variant="h3"
          sx={{
            mb: { xs: 3, md: 5 },
            fontSize: { xs: "2rem", md: "2.8rem" },
            textAlign: "center",
          }}
        >
          A closer look
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(2, minmax(0, 1fr))",
              md: "repeat(3, minmax(0, 1fr))",
            },
            gap: { xs: 1.5, md: 2.5 },
          }}
        >
          {images.map((src, index) => (
            <motion.button
              key={`${src}-${index}`}
              type="button"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: Math.min(index * 0.06, 0.24) }}
              onClick={() => {
                setCurrentImage(index);
                setLightboxOpen(true);
              }}
              aria-label={`View property photo ${index + 1}`}
              style={{
                display: "block",
                width: "100%",
                aspectRatio: index === 0 ? "1.2 / 1" : "1 / 1",
                overflow: "hidden",
                padding: 0,
                border: 0,
                background: "#d9d5ca",
                cursor: "pointer",
              }}
            >
              <img
                src={src}
                alt={`Property detail ${index + 1}`}
                loading="lazy"
                style={{
                  display: "block",
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transition: "transform 700ms ease",
                }}
              />
            </motion.button>
          ))}
        </Box>
      </Box>
      {lightboxOpen && (
        <Lightbox
          images={images.map((url) => ({ url }))}
          startIndex={currentImage}
          onClose={() => setLightboxOpen(false)}
        />
      )}
    </Box>
  );
};

export default ProjectGallery;
